import React, { useState, useRef, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import moment from 'moment'
import moment from 'moment-timezone';
import UserAvatar from "../components/UserAvatar";
import ReactDOM from "react-dom";

// import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
// import CheckBoxIcon from "@mui/icons-material/CheckBox";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

// import CheckIcon from '@mui/icons-material/Check';
// import EditIcon from '@mui/icons-material/Edit';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
// import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { ReactComponent as MessageIcon } from '../icons/Message.svg'
import { ReactComponent as EditOutlineIcon } from '../icons/EditOutlineIcon.svg'
import { ReactComponent as VisibilityOutlineIcon } from '../icons/VisibilityOutlineIcon.svg'


// import { DeleteConfirmationModal } from "../components/AppModal";
// import { useUpdateMembership } from '../hooks/memberhooks'
// import { statusColors } from "../utils/enums";
import { capitalizeWords, getBookingStatusColor } from "../utils/helpers";
import { ResourceBookingSchema } from "../data/types";
import { MemberDetailsModal, RequestDetailsModal, NewMessageModal } from "./AppModal";
import { useLoadMember } from '../hooks/memberhooks';


// const colors: {[key: string]: string} = statusColors();

type ResourceRequestRecordProps = {
  allRequests: ResourceBookingSchema[]
  request: ResourceBookingSchema
  isRequests?: boolean
}

type DropdownProps = {
  showDropdown: boolean
  toggleShowDropdown: React.Dispatch<React.SetStateAction<boolean>>
  requestId: string
  uid: string
  buttonRef: React.RefObject<HTMLDivElement>
  toggleViewRequestDetails: React.Dispatch<React.SetStateAction<boolean>>
  toggleViewMemberDetails: React.Dispatch<React.SetStateAction<boolean>>
  toggleSendMessage: React.Dispatch<React.SetStateAction<boolean>>
}

const Dropdown: React.FC<DropdownProps> = ({ 
  showDropdown, 
  toggleShowDropdown, 
  requestId, 
  uid, 
  buttonRef,
  toggleViewRequestDetails,
  toggleViewMemberDetails,
  toggleSendMessage
}) => {
  // const navigate = useNavigate();
  const [dropdownStyle, setDropdownStyle] = useState<React.CSSProperties>({});

  useEffect(() => {
    if (showDropdown && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownStyle({
        position: 'fixed',
        top: rect.bottom + 4,
        left: rect.left,
        zIndex: 9999,
        minWidth: rect.width + 80,
      });
    }
  }, [showDropdown, buttonRef]);

  const handleOptionClick = (option: string) => {
    switch(option) {
      case 'manage-status':
        // Handle status management
        break;
      case 'view-request':
        toggleViewRequestDetails(true);
        break;
      case 'view-profile':
        toggleViewMemberDetails(true);
        break;
      case 'send-message':
        toggleSendMessage(true);
        break;
    }
    toggleShowDropdown(false);
  };

  const dropdownMenu = (
    <ul 
      data-testid="request-actions-dropdown"
      className="border-[1px] rounded bg-white shadow z-50"
      style={dropdownStyle}
      onMouseLeave={() => toggleShowDropdown(false)}
    >
      {/* <li
        className="font-open-sans text-left text-[14px] font-medium cursor-pointer p-2 hover:bg-gray-100 text-gray-700"
        onClick={() => handleOptionClick('manage-status')}
      >
        Manage Status
      </li> */}
      <li
        className="flex flex-row items-center font-open-sans text-left text-[14px] font-medium cursor-pointer p-2 hover:bg-gray-100 text-gray-700"
        onClick={() => handleOptionClick('view-request')}
      >
        <EditOutlineIcon style={{fontSize: 18}} className="mr-2 w-5 h-5 text-[#A1A1A1]/70" /> 
        <p className="text-[14px] font-medium mr-2">Manage Request</p>
      </li>
      <li
        className="flex flex-row items-center font-open-sans text-left text-[14px] font-medium cursor-pointer p-2 hover:bg-gray-100 text-gray-700"
        onClick={() => handleOptionClick('view-profile')}
      >
        <VisibilityOutlineIcon style={{fontSize: 18}} className="mr-2 w-5 h-5 text-[#A1A1A1]/70" /> 
        <p className="text-[14px] font-medium">View Member</p>
      </li>

      <li
        className="flex flex-row items-center font-open-sans text-left text-[14px] font-medium cursor-pointer p-2 hover:bg-gray-100 text-gray-700"
        onClick={() => handleOptionClick('send-message')}
      >
        <MessageIcon style={{fontSize: 18}} className="mr-2 w-5 h-5 text-[#A1A1A1]/70" /> 
        <p className="text-[14px] font-medium">Send Message</p>
      </li>
    </ul>
  );

  return (
    <>
      {showDropdown && ReactDOM.createPortal(dropdownMenu, document.body)}
    </>
  );
};

const ResourceRequestRecord: React.FC<ResourceRequestRecordProps> = (props) => {
  const { allRequests,request } = props;
  const [dropdownIsOpen, toggleDropdownIsOpen] = useState(false);
  const [viewRequestDetails, toggleViewRequestDetails] = useState(false);
  const [viewMemberDetails, toggleViewMemberDetails] = useState(false);
  const [sendMessage, toggleSendMessage] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  const memberUid = request?.uid ? request.uid : "";
  const { currentMember } = useLoadMember(memberUid);
  // console.log("currentMember", currentMember)
  // console.log("memberUid", memberUid)
  const [imageError, setImageError] = useState(false);

  var dateFieldValue = ""
  switch(request.resource_type){
    case 'training':
      dateFieldValue =  moment(request.start_time).tz('America/New_York').format('ddd MMM DD, YYYY @ hh:mm a')
      break
    case 'expert':
      dateFieldValue =  moment(request.start_time).tz('America/New_York').format('ddd MMM DD, YYYY @ hh:mm a')
      break
    case 'kitchen':
      dateFieldValue =  moment(request.start_time).tz('America/New_York').format('ddd MMM DD, YYYY (hh:mm a') + ' - ' + moment(request.end_time).tz('America/New_York').format('hh:mm a)')
      break
  }

  // const circle = (status: string) => {
  //   return (
  //     <div
  //       className={`z-0 w-2 h-2 animate-pulse ${colors[status]} rounded-full`}
  //     ></div>
  //   );
  // };
  

  // const declineRequest = () => {
  //   if (updateMembership !== undefined) {
  //     updateMembership({username: request.username, status: request.status === 'declined' ? 'removed' : 'declined'})
  //  } 
  // }



  return (
    <>
      <tr className="hover:bg-gray-50">
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 cursor-pointer" onClick={() => toggleViewRequestDetails(true)}>
          <div className="flex items-center">
            {(currentMember?.avatar || request?.user_avatar) && !imageError ? (
              <img
                src={currentMember?.avatar || request?.user_avatar}
                alt="User Avatar"
                className="w-8 h-8 rounded-full mr-3"
                onError={() => setImageError(true)}
              />
            ) : (
              <UserAvatar
                firstName={currentMember?.first_name || request?.user_full_name?.split(' ')[0]}
                lastName={currentMember?.last_name || request?.user_full_name?.split(' ')[1]}
                username={currentMember?.username}
                email={currentMember?.email}
                size="sm"
                className="mr-3"
              />
            )}
            <span>
              {currentMember?.first_name && currentMember?.last_name
                ? `${currentMember.first_name} ${currentMember.last_name}`
                : request?.user_full_name || 'N/A'}
            </span>
          </div>
        </td>

        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 cursor-pointer" onClick={() => toggleViewRequestDetails(true)}>
          {request?.username}
        </td>

        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 cursor-pointer" onClick={() => toggleViewRequestDetails(true)}>
          {request?.resource_name || '-'}
        </td>

        {
          (dateFieldValue) && (
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 cursor-pointer" onClick={() => toggleViewRequestDetails(true)}>
              {dateFieldValue}
            </td>
          )
        }

        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 cursor-pointer" onClick={() => toggleViewRequestDetails(true)}>
          {moment.utc(request?.created).fromNow()}
        </td>

        <td className="px-6 py-4 whitespace-nowrap cursor-pointer" onClick={() => toggleViewRequestDetails(true)}>
          <div className="flex items-center">
            <span className="flex items-center text-sm" style={{color: getBookingStatusColor(request.status || '').primaryTextColor}}>
              <FiberManualRecordIcon style={{fontSize: 15}} />
              <span className="ml-1">
                {(request.status) ? capitalizeWords(request.status.replace(/_/g, ' ')) : 'Pending'}
              </span>
            </span>
          </div>
        </td>

        <td
          className="px-6 py-4 whitespace-nowrap text-sm text-gray-800"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center">
            <div 
              className="flex h-8 w-8 rounded-full border-2 border-gray-300 cursor-pointer hover:border-gray-400"
              data-testid="request-actions-menu"
              onClick={(e) => {
                e.stopPropagation();
                toggleDropdownIsOpen(prev => !prev);
              }}
              ref={buttonRef}
            >
              <MoreHorizIcon className="m-auto text-gray-500" style={{fontSize: 16}} />
            </div>
            {request.id && request.username && (
              <Dropdown 
                showDropdown={dropdownIsOpen}
                toggleShowDropdown={toggleDropdownIsOpen}
                requestId={request.id}
                uid={memberUid}
                buttonRef={buttonRef}
                toggleViewRequestDetails={toggleViewRequestDetails}
                toggleViewMemberDetails={toggleViewMemberDetails}
                toggleSendMessage={toggleSendMessage}
              />
            )}
          </div>
        </td>
      </tr>

      {currentMember && viewMemberDetails && ReactDOM.createPortal(
        <MemberDetailsModal 
          isOpen={viewMemberDetails} 
          closeAppModal={() => toggleViewMemberDetails(false)} 
          member={currentMember} 
        />,
        document.body
      )}

      {request?.id && viewRequestDetails && ReactDOM.createPortal(
        <RequestDetailsModal 
          isOpen={viewRequestDetails} 
          closeAppModal={() => toggleViewRequestDetails(false)} 
          allResourceRequests={allRequests}
          request={request} 
        />,
        document.body
      )}

      {currentMember?.username && sendMessage && ReactDOM.createPortal(
        <NewMessageModal 
          username={currentMember?.username}
          isOpen={sendMessage} 
          closeAppModal={() => toggleSendMessage(false)} 
        />,
        document.body
      )}
    </>
  );
};

export default ResourceRequestRecord;
